// src/firebase/firebase.js

import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  GithubAuthProvider,
  TwitterAuthProvider,
} from 'firebase/auth';
import { getDatabase } from 'firebase/database'; // Realtime Database
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import { getMessaging, isSupported } from 'firebase/messaging';

// ✅ Firebase Config using Environment Variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyB0maHumbnamVGqFWafgBkR9enhGmJQY1w',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'ecab-c4289.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'ecab-c4289',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'ecab-c4289.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '683629065947',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:683629065947:web:b198bbba9cd0b883407efe',
};

// ✅ Initialize Firebase safely
let app;
try {
  app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
} catch (error) {
  // eslint-disable-next-line no-console
  console.warn('Firebase initialization warning:', error);
}

// ✅ Initialize services
const auth = app ? getAuth(app) : null;
const database = app ? getDatabase(app) : null;
const storage = app ? getStorage(app) : null;
const firestore = app ? getFirestore(app) : null;

// ✅ Initialize Firebase Cloud Messaging safely (handles browser support and required appId)
let messaging = null;
const getMessagingInstance = async () => {
  if (messaging) return messaging;
  if (typeof window !== 'undefined' && app) {
    if (!firebaseConfig.appId) {
      // eslint-disable-next-line no-console
      console.warn(
        "[FCM] Missing 'appId' in Firebase configuration. Please set REACT_APP_FIREBASE_APP_ID in your .env file to enable Web Push Notifications."
      );
      return null;
    }
    try {
      const supported = await isSupported();
      if (supported) {
        messaging = getMessaging(app);
        return messaging;
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('FCM messaging is not supported in this browser:', err);
    }
  }
  return null;
};

// ✅ Initialize social providers
const googleAuthProvider = new GoogleAuthProvider();
const facebookAuthProvider = new FacebookAuthProvider();
const githubAuthProvider = new GithubAuthProvider();
const twitterAuthProvider = new TwitterAuthProvider();

// ✅ Export for use in other files
export {
  app,
  auth,
  database,
  storage,
  firestore,
  firestore as db,
  getMessagingInstance,
  firebaseConfig,
  googleAuthProvider,
  facebookAuthProvider,
  githubAuthProvider,
  twitterAuthProvider,
};
